<proffeo-ui-card
  variant="flat"
  density="compact"
  class="flex flex-col gap-2 p-3"
>
  <span class="font-medium">{{ 'time-reports.report-entry.summary' | translate }}</span>

  <div class="grid grid-cols-2 gap-x-4 gap-y-2 sm:grid-cols-3">
    @if (date()) {
      <div class="flex flex-col">
        <span class="text-xs opacity-70">{{ 'time-report-date' | translate }}</span>
        <span class="font-medium">{{ date() | date }}</span>
      </div>
    } @else if (periodLabel()) {
      <div class="flex flex-col">
        <span class="text-xs opacity-70">{{ 'time-reports.report-entry.summary-period' | translate }}</span>
        <span class="font-medium">{{ periodLabel() }}</span>
      </div>
    }
    @if (modeLabelKey()) {
      <div class="flex flex-col">
        <span class="text-xs opacity-70">{{ 'time-reports.report-entry.summary-type' | translate }}</span>
        <span class="font-medium">{{ modeLabelKey() | translate }}</span>
      </div>
    }
    @if (timeLabel()) {
      <div class="flex flex-col">
        <span class="text-xs opacity-70">{{ 'time-reports.report-entry.summary-time' | translate }}</span>
        <span class="font-medium">{{ timeLabel() }}</span>
      </div>
    }
    @if (breakLabel()) {
      <div class="flex flex-col">
        <span class="text-xs opacity-70">{{ 'time-reports.report-entry.summary-break' | translate }}</span>
        <span class="font-medium">{{ breakLabel() }}</span>
      </div>
    }
    <div class="flex flex-col">
      <span class="text-xs opacity-70">{{ 'time-reports.report-entry.summary-days' | translate }}</span>
      <span class="font-medium">{{ days() }}</span>
    </div>
    <div class="flex flex-col">
      <span class="text-xs opacity-70">{{ perDayLabelKey() | translate }}</span>
      <span class="font-medium">{{ durationPerDayLabel() }}</span>
    </div>
    <div class="flex flex-col">
      <span class="text-xs opacity-70">{{ 'time-reports.report-entry.summary-total' | translate }}</span>
      <span class="font-medium">{{ totalLabel() }}</span>
    </div>
    @if (typeLabel()) {
      <div class="flex flex-col">
        <span class="text-xs opacity-70">{{ 'time-reports.report-entry.summary-type' | translate }}</span>
        <span class="font-medium">{{ typeLabel() }}</span>
      </div>
    }
    @if (projectLabel()) {
      <div class="flex flex-col">
        <span class="text-xs opacity-70">{{ 'time-reports-export.columns.project' | translate }}</span>
        <span class="font-medium">{{ projectLabel() }}</span>
      </div>
    }
    @if (taskLabel()) {
      <div class="flex flex-col">
        <span class="text-xs opacity-70">{{ 'time-reports-export.columns.task' | translate }}</span>
        <span class="font-medium">{{ taskLabel() }}</span>
      </div>
    }
    @if (locationLabel()) {
      <div class="flex flex-col">
        <span class="text-xs opacity-70">{{ 'time-reports-export.columns.location' | translate }}</span>
        <span class="font-medium">{{ locationLabel() }}</span>
      </div>
    }
  </div>

  @if (createdByName()) {
    <div class="flex flex-col gap-0.5 pt-1">
      <span class="text-sm">{{ 'time-reports.report-entry.created-by' | translate }} «{{ createdByName() }}»</span>
      @if (createdAt()) {
        <span class="text-sm">
          {{ 'time-reports.report-entry.created-at' | translate }}
          {{ createdAt() | date }}
          {{ 'time-reports.report-entry.created-at-time' | translate }}
          {{ createdAt() | date: 'shortTime' }}
        </span>
      }
    </div>
  }
</proffeo-ui-card>
